export default "<p>revenue-statistics works!</p>\n";